// extracted by mini-css-extract-plugin
export default {"form":"ResetPassword_form__llB8Z","input":"ResetPassword_input__Agi6b","container":"ResetPassword_container__Nj7Xl","submit":"ResetPassword_submit__wUTzz"};